<template>
  <div class="cotton-device-monitor">
    <InspectionCard :data="cd602DeviceList" />

    <DetectionCard :deviceList="cd603DeviceList" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DetectionCard from './components/DetectionCard/index.vue';
import InspectionCard from './components/InspectionCard/index.vue';

import ctt from '@/utils/const/index';
import { isEmpty } from '@/utils/is';
import { openDevicePointMap } from '@/components/bmapGL/dialog';
import { setDeviceCoordinate } from '@/layout/commonActions/setDeviceCoordinate';
import { getStateHighLevelOptionBy } from '@/utils/deviceUtils/state';

export default {
  components: {
    DetectionCard,
    InspectionCard
  },
  sockets: {
    '/socket/basic'(res) {
      try {
        const dict = {
          [ctt.CD_602]: this.handleCD602BasicData,
          [ctt.FR_01]: this.handleFR01BasicData
        };

        if (!(res.deviceType in dict)) return;

        dict[res.deviceType]?.call(this, res);
      } catch (error) {
        console.log(error);
      }
    }
  },
  data() {
    return {
      deviceTree: [],
      fr01RefreshKey: 0
    };
  },
  provide() {
    return {
      locateTo: params => this.showDevicePosition(params),
      setDevicePosition: params => this.setDevicePosition(params)
    };
  },
  computed: {
    ...mapState('socket', {
      deviceSNMap: 'deviceSNMap',
      deviceIdMap: 'deviceIdMap',
      allDeviceList: 'devicesSourseMap'
    }),
    deviceList() {
      const id = this.$route.params.id;

      if (isEmpty(id)) return this.allDeviceList;

      const list = this.deviceIdMap[id]?.children;

      return isEmpty(list) ? [] : list;
    },
    cd603DeviceList() {
      const list = this.deviceList.filter(e => e.deviceType === ctt.CD_603);

      const temp = isEmpty(list) ? [] : list;

      return temp.sort(
        (a, b) => getStateHighLevelOptionBy([b], {}).l2 - getStateHighLevelOptionBy([a], {}).l2
      );
    },
    cd602DeviceList() {
      const list = this.deviceList.filter(e => e.deviceType === ctt.CD_602);

      const temp = isEmpty(list) ? [] : list;

      return temp.sort(
        (a, b) => getStateHighLevelOptionBy([b], {}).l2 - getStateHighLevelOptionBy([a], {}).l2
      );
    }
  },
  methods: {
    handleFR01BasicData(_res) {
      // const { sn, beginTimeD } = res;
      // const device = this.cd603DeviceList.find(e => e.sn === sn);
      // this.fr01RefreshKey++;
      // device.beginTimeD = beginTimeD;
    },
    handleCD602BasicData(_res) {
      // console.log(res);
      // const { sn, modState, batteryPercent, isCharging, longitude, latitude } = res;
      // const { state } = modState?.cd602Mod;
      // const index = this.cd602DeviceList.findIndex(e => e.sn === sn);
      // const item = this.cd602DeviceList[index];
      // if (item) {
      // this.$set(item, 'state', state);
      // this.$set(item, 'batteryPercent', batteryPercent);
      // this.$set(item, 'isCharging', isCharging);
      // this.$set(item, 'gps', [longitude, latitude]);
      // Object.assign(item, {
      //   state,
      //   gps: [longitude, latitude],
      //   batteryPercent,
      //   isCharging
      // });
      // } else {
      //   console.warn('未找到设备', sn);
      // }
    },
    showDevicePosition(deviceInfo) {
      let { latitude, longitude, gps, sn, name } = deviceInfo;

      if (!isEmpty(gps)) {
        [longitude, latitude] = gps;
      }

      console.log(name);

      openDevicePointMap({ coords: { longitude, latitude }, useRealTime: true, sn, name });
    },
    setDevicePosition(deviceInfo) {
      setDeviceCoordinate(deviceInfo);
    }
  }
};
</script>

<style lang="scss">
.cotton-device-monitor {
  position: relative;
  height: 100%;

  --mtable-border-color: var(--cotton-monitor-mtable-border-color);
  --mtable-bg-color: var(--cotton-monitor-mtable-bg-color);
  --mtable-color: var(--cotton-monitor-mtable-color);
  --mtable-thead-color: var(--cotton-monitor-mtable-thead-color);
  --mtable-wrap-border: unset;
  --mtable-thead-fs: 18px;
  --mtable-tbody-fs: 16px;

  --top-p1: calc(37% - var(--gap));
  --top-p2: calc(37% - var(--gap));
  --top-p3: 26%;

  width: 100%;
  height: 100%;

  pointer-events: none;

  .m-table {
    width: 100%;
    height: 100%;

    .button-box {
      .el-button {
        width: 100%;
      }
    }

    .el-table__body-wrapper {
      @include scrollar-style-thin;
    }
  }

  & > * {
    pointer-events: auto;
  }

  .gps {
    white-space: pre-line;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    cursor: pointer;

    transition: color 0.7s;

    &:hover {
      color: var(--cotton-monitor-gps-hover-color);
      filter: brightness(1.5);
    }

    .iconfont {
      font-size: 28px;
    }

    &-text {
      text-align: left;
    }
  }

  .cotton-button {
    color: var(--cotton-monitor-btn-text) !important;
    background-color: var(--cotton-monitor-btn-bg) !important;
    border-color: var(--cotton-monitor-btn-bg) !important;

    &.is-disabled {
      background-color: var(--cotton-monitor-btn-disabled-bg) !important;
      border-color: var(--cotton-monitor-btn-disabled-bg) !important;
    }
  }
}
</style>
